module.exports = __webpack_public_path__ + "media/images/emoticons/ok-5e89df1987da6877377344459a5c5d14.gif";